import React, {useState} from 'react';
import {Button, Flex, Modal} from "antd";
import {Document, Page} from "react-pdf";
import IntlMessage from "../../../../../../components/IntlMessage/IntlMessage";
import MyText from "../../../../../../components/UI/Text/MyText";
import GreyButton from "../../../../../../components/UI/Buttons/GreyButton";

const DocumentPreviewModal = ({
                                  open,
                                  onClose,
                                  documentPdf,
                                  onDocumentLoadSuccess,
                                  isLoading,
                                  onDownload
                              }) => {
    const [pageNumber, setPageNumber] = useState(1);
    const [numPages, setNumPages] = useState(null);

    const handleLoadSuccess = ({numPages}) => {
        setNumPages(numPages);
        if (onDocumentLoadSuccess) {
            onDocumentLoadSuccess({numPages});
        }
    };

    return (
        <Modal
            width={800}
            maskClosable={true}
            open={open}
            okText={<IntlMessage id={'save'}/>}
            cancelText={<IntlMessage id={'close'}/>}
            style={{top: 20}}
            onOk={onClose}
            onCancel={onClose}
            loading={isLoading}
            footer={[
                <Button key="submit" type="primary" onClick={onClose}>
                    OK
                </Button>
            ]}
        >
            {open && (
                <Flex
                    gap={50}
                    style={{
                        width: "100%",
                        minHeight: "calc(100vh - 300px)",
                        position: "relative",
                        padding: "0px 20px 20px 0px",
                    }}
                    vertical
                    align={"flex-start"}
                    justify={"flex-start"}
                >
                    <Flex
                        align={"center"}
                        justify={"center"}
                        vertical
                        style={{overflowX: "auto", overflowY: "hidden", width: "100%"}}
                    >
                        <Flex
                            style={{
                                zIndex: 1,
                                padding: "10px 20px",
                                backgroundColor: "white",
                                borderRadius: 10,
                                boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.1)",
                            }}
                            gap={15}
                            justify={"space-between"}
                            align={"center"}
                        >
                            <Button
                                disabled={pageNumber === 1}
                                onClick={() => setPageNumber(pageNumber - 1)}
                            >
                                {'<'}
                            </Button>
                            <MyText size={"small"}>
                                {pageNumber} / {numPages}
                            </MyText>
                            <Button
                                disabled={pageNumber === numPages}
                                onClick={() => setPageNumber(pageNumber + 1)}
                            >
                                {'>'}
                            </Button>
                        </Flex>
                        <div style={{border: '1px solid black', marginTop: 10}}>
                            <Document
                                file={documentPdf}
                                onLoadSuccess={handleLoadSuccess}
                                loading={<IntlMessage id={'documentIsLoading'}/>}
                            >
                                <Page pageNumber={pageNumber} width={700}/>
                            </Document>
                        </div>
                    </Flex>
                    {onDownload && (
                        <Flex align={"flex-start"} justify={"center"} gap={20} style={{width: "100%"}}>
                            <GreyButton onClick={onDownload}>
                                <IntlMessage id={'download'}/>
                            </GreyButton>
                        </Flex>
                    )}
                </Flex>
            )}
        </Modal>
    );
};

export default DocumentPreviewModal;
